import React, { Component } from "react";
import { Row } from "antd";

export default class Auth extends Component {
  render() {
    return (
      <div>
        <Row className="auth-logo" type="flex" justify="center" align="middle">
          <img
            alt="logo"
            height="49"
            width="145"
            src="https://s3.amazonaws.com/wesolv-assets/logo.svg"
          />
        </Row>
        <div>{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/index.js